import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import StoreItem from './StoreItem';
import defaultClasses from '../searchResults.module.css';

var StoreList = function StoreList(_ref) {
  var storesNearby = _ref.storesNearby,
      viewAll = _ref.viewAll,
      shownStores = _ref.shownStores,
      setShownStores = _ref.setShownStores,
      setNewPosition = _ref.setNewPosition,
      calculateRoute = _ref.calculateRoute,
      coordinates = _ref.coordinates,
      predefinedCoordinates = _ref.predefinedCoordinates,
      onGetDirection = _ref.onGetDirection,
      initAvailableStoreLocationCount = _ref.initAvailableStoreLocationCount;
  var withRes = []; // this is array with items which have label and we show them first, sorted by priority

  var nonRes = []; // array with items which don't have label, and we sort them by distance

  storesNearby === null || storesNearby === void 0 ? void 0 : storesNearby.map(function (item) {
    var _item$group;

    var sum = 0;
    (_item$group = item.group) === null || _item$group === void 0 ? void 0 : _item$group.map(function (item) {
      if (item.name === 'Gallery Dealer') {
        sum += 6;
      } else if (item.name === 'Display Dealer') {
        sum += 3;
      } else if (item.name === 'To the Trade') {
        sum += 11;
      } else {
        sum += 1;
      }
    });
    return _objectSpread(_objectSpread({}, item), {}, {
      sum: sum
    });
  }).sort(function (a, b) {
    if (a.sum > b.sum) {
      return -1;
    }

    if (a.sum < b.sum) {
      return 1;
    }

    return 0;
  }).map(function (item) {
    if (item.sum > 0) {
      withRes.push(item);
    } else {
      nonRes.push(item);
    }
  }); // item with lower distance going fist

  var sortByDistance = nonRes.sort(function (a, b) {
    if (a.distance > b.distance) {
      return 1;
    }

    if (a.distance < b.distace) {
      return -1;
    }

    return 0;
  });
  var finalResult = [].concat(withRes, _toConsumableArray(sortByDistance));
  var initAvailableStoreLocations = finalResult.slice(0, initAvailableStoreLocationCount);
  return React.createElement("div", {
    className: "max-h-[40rem] overflow-auto"
  }, React.createElement("ul", {
    className: "".concat(defaultClasses.storeList)
  }, viewAll ? initAvailableStoreLocations.map(function (store, index) {
    return React.createElement(StoreItem, {
      onGetDirection: onGetDirection,
      predefinedCoordinates: predefinedCoordinates,
      key: "search-results-store-list-item-".concat(store.store_id),
      index: index,
      store: store,
      shownStores: shownStores,
      setShownStores: setShownStores,
      setNewPosition: setNewPosition,
      calculateRoute: calculateRoute,
      coordinates: coordinates
    });
  }) : finalResult.map(function (store, index) {
    return React.createElement(StoreItem, {
      onGetDirection: onGetDirection,
      predefinedCoordinates: predefinedCoordinates,
      key: "search-results-store-list-item-".concat(store.store_id),
      index: index,
      store: store,
      shownStores: shownStores,
      setShownStores: setShownStores,
      setNewPosition: setNewPosition,
      calculateRoute: calculateRoute,
      coordinates: coordinates
    });
  })));
};

export default StoreList;